import { type Credential } from '@iichi/domain/member';

export const IichiEnv = {
  DEV: 'dev',
  STAGE: 'stage',
  PROD: 'prod',
} as const satisfies Record<string, string>;
export type IichiEnv = (typeof IichiEnv)[keyof typeof IichiEnv];

export interface User {
  credentials: Credential[];
}

export interface Member {
  alias: string;
  member_id: number;
  member_name: string;
  email: string;
  picture_path: string;
  prefecture: string;
  slug: string;
  a: boolean;
  b: boolean;
  permissions: number[];
}

export interface Shop {
  is_on_vacation: boolean;
  first_listed_at: number; // Unix timestamp
  last_listed_at: number; // Unix timestamp
  max_listing_count: number;
}

export type Topic =
  | { type: 'info'; props: { text: string } }
  | { type: 'warning'; props: { text: string } }
  | { type: 'welcome'; props: { email: string } }
  | { type: 'confirmationRequired' }
  | { type: 'emailConfirmed'; props: { fromNative: string } }
  | { type: 'signupComplete'; props: { fromNative: string } }
  | { type: 'permissionRequired'; props: { permissionId: string } };

const Pallet: {
  iichiEnv: IichiEnv;
  User: User;
  Member?: Member;
  Topics: Topic[];
  Item?: {
    itemId: number;
  };
  InstagramShopping?: {
    reload: boolean;
  };
  NoteStore?: {
    reload: boolean;
  };
  Payment?: {
    tokenApiKey: string;
  };
  microcms?: {
    apiKey: string;
  };
  cloudflare?: {
    turnstileSiteKey: string;
  };
  Yappli?: {
    token: string;
  };
} = window.Pallet || { iichiEnv: IichiEnv.PROD };

export default {
  Pallet, // サーバー側から受け取る値
};
